import { capitalize } from "./string";

export const formatarDataAmigavel = (date) => {
  if (!date) {
    return "";
  }

  return capitalize(
    new Date(date).toLocaleDateString("pt-BR", {
      month: "long",
      year: "numeric",
    })
  );
};

export const formatarDataDiaAmigavel = (date) => {
  if (!date) {
    return "";
  }

  return capitalize(
    new Date(date).toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    })
  );
};

export const formatarData = (date) => {
  if (!date) {
    return "";
  }

  let fullDate = date;
  if (typeof fullDate === "string" && fullDate.length < 11) {
    fullDate = `${date}T03:00:00.000Z`;
  }

  const dateFormatted = new Date(fullDate).toLocaleDateString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
  return `${dateFormatted}`;
};

export const formatarDataBR = (date) => {
  if (!date) {
    return "";
  }

  let fullDate = date;
  if (typeof fullDate === "string" && fullDate.length < 11) {
    fullDate = `${date}T03:00:00.000Z`;
  }

  const [dia, mes, ano] = fullDate.split(" ")[0].split("/").map(Number);

  const dateFormatted = new Date(ano, mes - 1, dia).toLocaleDateString(
    "pt-BR",
    {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    }
  );
  return `${dateFormatted}`;
};

export const formatarDataDiaMes = (date) => {
  if (!date) {
    return "";
  }

  const dateFormatted = new Date(date).toLocaleDateString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
  });
  return `${dateFormatted}`;
};

export const formatarDataMes = (date, shouldCapitalize = true) => {
  if (!date) {
    return "";
  }

  const dateFormatted = new Date(date).toLocaleDateString("pt-BR", {
    month: "long",
  });
  return shouldCapitalize ? `${capitalize(dateFormatted)}` : dateFormatted;
};

export const parseDate = (date) => {
  const now = date ? new Date(date) : new Date();

  const day = now.getUTCDate();
  const month = now.getMonth();
  const year = now.getFullYear();

  return {
    dia: `${day + 1}`.padStart(2, "0"),
    mes: `${month + 1}`.padStart(2, "0"),
    ano: `${year}`,
  };
};

export const formatarTempo = (date) => {
  if (!date) {
    return "";
  }

  const timeFormatted = new Date(date).toLocaleTimeString("pt-BR", {
    hour12: false,
  });

  return `${timeFormatted}`;
};

export const formatarDataServidor = (date) => {
  if (!date) {
    return "1900-01-01";
  }
  if (date.split("/").length !== 3) {
    return date;
  }

  const [day, month, year] = date.split("/");
  return [year, month, day].join("-");
};

export const formatarDataForm = (date) => {
  if (!date) {
    return "1900-01-01T00:00:00";
  }
  if (date.split("-").length !== 3) {
    return date;
  }

  const [year, month, day] = date.split("-");
  const result = [day, month, year].join("/");
  return `${result}`;
};
